
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 257","d":"M55.34 33.82C50.45 21.11 33 20.42 37.23 1.94A1.57 1.57 0 0034.89.23a29.08 29.08 0 00-12.62 37.55 1.55 1.55 0 01-.87 2 1.57 1.57 0 01-1.47-.18 15.51 15.51 0 01-5.73-14.8 1.56 1.56 0 00-2.84-1.06 29.32 29.32 0 00-4.27 16.38 25.1 25.1 0 0021.23 23.49A26.74 26.74 0 0050 57.79a21.56 21.56 0 005.34-23.97zM26.42 49.5a9.61 9.61 0 007.41-7.2c1-4.46-3-8.82-.28-15.87 1 5.83 10.19 9.48 10.19 15.84.26 7.88-8.29 14.65-17.32 7.23z"}})])
          )
        }
      }
    